import { useEffect, useState } from 'react';

/**
 * Page qui génère dynamiquement le sitemap.xml en fonction du domaine
 * Route: /sitemap.xml
 * 
 * Cette page fait un proxy vers la Edge Function Supabase qui génère le sitemap
 */
export const SitemapXML = () => {
  const [sitemapXML, setSitemapXML] = useState<string>('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSitemap = async () => {
      try {
        // Récupérer le domaine actuel
        const domain = window.location.hostname;
        
        console.log('🌐 Fetching sitemap for domain:', domain);
        
        // Appeler la Edge Function avec le domaine
        const response = await fetch(
          `https://pgnkuxeckqnzkyfcrwzs.supabase.co/functions/v1/sitemap?domain=${domain}`
        );
        
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const xml = await response.text();
        setSitemapXML(xml);
        
        console.log('✅ Sitemap fetched successfully');
      } catch (error) {
        console.error('❌ Error fetching sitemap:', error);
        setSitemapXML('<?xml version="1.0" encoding="UTF-8"?><urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9"></urlset>');
      } finally {
        setLoading(false);
      }
    };

    fetchSitemap();
  }, []);

  useEffect(() => {
    if (!loading && sitemapXML) {
      // Remplacer tout le contenu HTML par du XML brut
      const htmlElement = document.documentElement;
      
      // Supprimer tous les éléments HTML
      while (htmlElement.firstChild) {
        htmlElement.removeChild(htmlElement.firstChild);
      }
      
      // Créer un nœud de texte avec le XML
      const textNode = document.createTextNode(sitemapXML);
      htmlElement.appendChild(textNode);
    }
  }, [loading, sitemapXML]);

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        fontFamily: 'Arial, sans-serif',
        color: '#666'
      }}>
        Génération du sitemap...
      </div>
    );
  }

  return null;
};
